// レスポンシブ設定の定数定義
export const MOBILE_HEADER_CONFIG = {
  minHeight: 96, // モバイルヘッダーの最小高さ（2行対応）
  paddingY: 1, // 垂直方向のパディング（theme単位）
  paddingTop: 15, // コンテンツ上部マージン（theme単位）
  contentPaddingTop: 136, // ヘッダー96px + 余白40px
  // 注意: paddingTopは8pxベース（MUIのtheme.spacing(1) = 8px）で計算
} as const
